/* eslint-disable no-unused-vars */
import React from "react";
// import { Image } from "react-bootstrap";
import { PHONE_REGEX, parseHtml, toWebp } from "../../../utils/common";
import { useRouter } from "next/router";
import Link from "next/link";
import * as yup from "yup";
import dynamic from "next/dynamic";
import Image from "next/image";

const HocButton = dynamic(() => import('../../HigherOrderComponent/HocButton'))
const BannerHireNowForm = dynamic(() => import('../../forms/banner-hire-now-form'))

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

function ServiceFullBanner(props) {
	let block = props.block;
	let showTags = props.showTags;
	let ctaButton = block.button.length > 0 ? block.button[0] : block.button;

	const router = useRouter();
	const isSalesForcePage = router.query.slug === "hire-salesforce-developer";

	const bannerFormSchema = yup
		.object({
			employee_name: yup.string().required("Name is required."),
			employee_email: yup
				.string()
				.email("Email is not valid.")
				.required("Email is required."),
			contact_no: yup
				.string()
				.min(10, "Invalid phone number")
				.max(13, "Invalid phone number")
				.matches(PHONE_REGEX, "Invalid phone number"),
			company_name: yup.string(),
			requirements: yup.string().required("Requirements are required."),
		})
		.required();

	const bannerFormInitialValues = {
		employee_name: "",
		employee_email: "",
		contact_no: "",
		company_name: "",
		requirements: "",
	};

	return (
		<>
			<section className="agile-banner-section agile-full-banner technologies-full-banner technologies-update-banner-section">
				<div className="agile-banner-inner">
					<div className="container">
						<div className="row">
							<div
								className={
									isSalesForcePage
										? "col-lg-6 col-md-12 col-sm-12 col-12"
										: "col-lg-8 col-md-8 col-sm-7 col-12"
								}
							>
								<div className="agile-banner-content">
									{isSalesForcePage && (
										<div className="mb-2">
											{block?.image_widgets.data?.[0]
												?.attributes.url ? (
												<Image
													priority={true}
													width={270}
													height={66}
													sizes="(max-width: 768px) 75vw, (max-width: 1200px) 40vw, 25vw"
													// layout="responsive"
													loading={'eager'}
													quality={75}
													blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAAI2AQMAAAD5PRqUAAAAA1BMVEX29vYACyOqAAAANklEQVR42u3BMQEAAADCIPunNsReYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAcoA8AAEvqX8xAAAAAElFTkSuQmCC"
													placeholder='blur' // "empty" | "blur"
													src={toWebp(
														`${baseUrl}${block?.image_widgets.data?.[0]?.attributes.url}`
													)}
													alt={
														block?.image_widgets
															.data?.[0]
															?.attributes
															?.alternativeText ||
														block?.image_widgets
															.data?.[0]
															?.attributes?.name
													}
												/>
											) : (
												<></>
											)}
										</div>
									)}
									<div className="heading">
										<h1 className="page-heading">
											{block.title}
										</h1>
										<h3>{block.short_title}</h3>
										{block.description
											? parseHtml(block.description, true)
											: ""}
									</div>
									{isSalesForcePage &&
										block?.tags?.length && (
											<div className="salesforce-listing">
												<ul className="salesforce-list-chip">
													{block?.tags.map((tag) => (
														<li key={tag.id}>
															{tag?.Title}
														</li>
													))}
												</ul>
											</div>
										)}

									{!isSalesForcePage && ctaButton?.label && (
										<HocButton
											button={ctaButton}
											btnAction={() => { }}
										>
											<Link
												href={ctaButton?.href}
												target={
													ctaButton?.target ===
														"_blank"
														? "_blank"
														: "_self"
												}
												className="btn btn-primary"
											>
												{ctaButton?.label}
											</Link>
										</HocButton>
									)}

									{!isSalesForcePage &&
										showTags &&
										block?.tags?.length ? (
										<div className="agile-banner-notes">
											<ul className="banner-notes-list">
												{block?.tags.map((tag) => (
													<li key={tag.id}>
														<p>{tag?.Title}</p>
													</li>
												))}
											</ul>
										</div>
									) : (
										<></>
									)}
								</div>
							</div>
							{isSalesForcePage ? (
								<div className="col-lg-6 col-md-12 col-sm-12 col-12">
									<section className="book-section tech-book-section salesForce technologies-contact-box-section">
										<div className="book-inner">
											<div className="floating-form-wrapper">
												<h3 className="mb-4 hire-now-form-title">
													Request the best match
													Salesforce expertise in
													minutes with TRooTech
												</h3>
												<BannerHireNowForm
													schema={bannerFormSchema}
													initialValues={
														bannerFormInitialValues
													}
												/>
											</div>
										</div>
									</section>
								</div>
							) : (
								<div className="col-lg-4 col-md-4  col-sm-5 col-12">
									<div className="agile-banner-img">
										{block?.image_widgets.data?.[0]
											?.attributes.url ? (
											<Image
												priority={true}
												width={402}
												height={402}
												sizes="(max-width: 768px) 75vw, (max-width: 1200px) 40vw, 25vw"
												// layout="responsive"
												loading={'eager'}
												quality={75}
												blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAcIAAAI2AQMAAAD5PRqUAAAAA1BMVEX29vYACyOqAAAANklEQVR42u3BMQEAAADCIPunNsReYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAcoA8AAEvqX8xAAAAAElFTkSuQmCC"
												placeholder='blur' // "empty" | "blur"
												src={toWebp(
													`${baseUrl}${block?.image_widgets.data?.[0]?.attributes.url}`
												)}
												alt={
													block?.image_widgets
														.data?.[0]?.attributes
														?.alternativeText ||
													block?.image_widgets
														.data?.[0]?.attributes
														?.name
												}
											/>
										) : (
											<></>
										)}
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default ServiceFullBanner;

